<template>
  <div class="popover-menu__text-input">
    <DebounceUpdate @update="(text) => $emit('update', text)" v-slot="{ debounced, instant }">
      <ProsemirrorInputBox
        class="source-detail-header-text-field"
        :model-value="modelValue"
        :placeholder="placeholder"
        :label="label"
        :max-length="Infinity"
        @update:model-value="debounced"
        @change="instant"
        double-height
      />
    </DebounceUpdate>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PopoverMenuTextInput',
  emits: { update: null },

  props: {
    modelValue: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: null,
    },
  },
});
</script>

<style lang="scss" scoped>
.popover-menu__text-input {
  padding: 4px 8px;

  ~ .popover-menu__text-input {
    padding-top: 8px;
  }
}

.popover-menu__text-input-label {
  font-size: 13px;
  font-weight: 500;
}
</style>
